import styled from 'styled-components';
import { bottom, left, right, top, zIndex } from 'styled-system';
import { Box } from '../Box/Box';
/**
 * @public
 */
export const Relative = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Relative",
  componentId: "sc-us5x91-0"
})(["position:relative;", " ", " ", " ", " ", ""], top, bottom, left, right, zIndex);
Relative.displayName = 'Relative';